
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 24 24"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M15 9.01c-1.654 0-3-1.346-3-3s1.346-3 3-3 3 1.346 3 3-1.346 3-3 3zm0-4.5c-.827 0-1.5.673-1.5 1.5s.673 1.5 1.5 1.5 1.5-.673 1.5-1.5-.673-1.5-1.5-1.5z"}}),_c('path',{attrs:{"d":"M18.75 13.51a.75.75 0 01-.75-.75c0-1.654-1.346-3-3-3a.75.75 0 010-1.5c2.481 0 4.5 2.019 4.5 4.5a.75.75 0 01-.75.75z"}}),_c('path',{attrs:{"d":"M15.75 19.51a.75.75 0 010-1.5h.75v-1.5h-2.25a.75.75 0 010-1.5h7.5a.75.75 0 00.75-.75v-12a.75.75 0 00-.75-.75h-18a.75.75 0 00-.75.75v2.25a.75.75 0 01-1.5 0V2.26A2.252 2.252 0 013.75.01h18A2.252 2.252 0 0124 2.26v12a2.252 2.252 0 01-2.25 2.25H18v1.5h1.5a.75.75 0 010 1.5h-3.75zM14.25 24.01a.75.75 0 01-.75-.75c0-3.308-2.692-6-6-6s-6 2.692-6 6a.75.75 0 01-1.5 0c0-4.135 3.365-7.5 7.5-7.5s7.5 3.365 7.5 7.5a.75.75 0 01-.75.75z"}}),_c('path',{attrs:{"d":"M7.5 15.76a4.88 4.88 0 01-4.875-4.875c0-.839.221-1.67.639-2.404.017-.035.035-.06.045-.075A4.9 4.9 0 017.5 6.01c2.388 0 4.453 1.777 4.814 4.138a.689.689 0 01.022.153c.027.217.039.403.039.584A4.88 4.88 0 017.5 15.76zm-3.269-5.714A3.379 3.379 0 007.5 14.259a3.381 3.381 0 003.34-2.885 7.633 7.633 0 01-6.609-1.328zm.71-1.356a6.103 6.103 0 003.951 1.435c.621 0 1.231-.093 1.818-.277A3.395 3.395 0 007.5 7.51c-.985 0-1.919.436-2.559 1.18z"}})])
          )
        }
      }
    